import Context from "shared/util/Context";

export function getValueForPromoDesign(design) {
	const attrs = {
		profilephoto: `profile photo - limit ${Context.get("likesCapTotal")}`,
		whoLikesYouTiles: "who likes you tiles",
		noLikesBoostUpsell: "no likes boost upsell",
	};

	return attrs[design];
}



// WEBPACK FOOTER //
// ./src/analytics/util/queryParamsMap.js